import { render, staticRenderFns } from "./FundGroupManager.vue?vue&type=template&id=490c3416&"
import script from "./FundGroupManager.vue?vue&type=script&lang=js&"
export * from "./FundGroupManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports